import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Modal, Grid, Input, Icon, Table } from 'semantic-ui-react';

import cm from 'helpers/commons';
import { Commons } from 'components';

const propTypes = {};

const defaultProps = {};

class StaffSearchModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      keyword: null
    };
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.modal.open) {
      this.setState({ keyword: null });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    let result = false;
    if (nextProps.modal.open || this.props.modal.open) {
      result = true;
    }
    return result;
  }

  handleEvent = () => {
    const { keyword } = this.state;
    const { staffSel } = this.props;

    staffSel(1, keyword);
  };

  handleChange = (e) => {
    this.setState({ keyword: e.target.value });
  };

  handleEntEvent = (e) => {
    if (e.key === 'Enter') {
      this.handleEvent();
    }
  };

  staffClick = (data) => {
    const { choiceEvent } = this.props;
    choiceEvent(data);
    // choiceEvent(data.name, data.id);
  };

  pageClick = async (page) => {
    const { keyword } = this.state;
    const { staffSel } = this.props;

    await staffSel(page, keyword);
    // this.staffSel()
  };

  render() {
    const { open, dimmer, close, size } = this.props.modal;
    const { staffList, title } = this.props;
    const { keyword } = this.state;

    const dom = document.getElementsByClassName('modal')[0];
    const style = {
      content: {
        width: dom ? dom.offsetWidth : null,
        overflow: 'auto'
      },
      grid: {
        width: '1340px'
      }
    };

    const header = [
      { data: 'ID', textAlign: 'left' },
      { data: '이름', textAlign: 'left' },
      { data: '이메일', textAlign: 'left' },
      { data: '휴대전화번호', textAlign: 'left' },
      { data: '직위', textAlign: 'left' },
      { data: '직책', textAlign: 'left' },
      { data: '권한', textAlign: 'left' }
    ];

    const main = cm.tableHeaderList(header, 2, false, 'default');

    const tabledata = {
      header: {
        main
      },
      body: {
        message: '내역이 존재하지 않습니다.',
        main: null
      },
      footer: null
    };

    let page = 1;
    let pagerow = 10;
    let totalcount = 0;

    if (staffList && staffList.data.user) {
      const { paging, user } = staffList.data;

      if (paging) {
        page = paging.page;
        pagerow = paging.pagerow;
        totalcount = paging.totalcount;
      }

      if (user && user.length > 0) {
        tabledata.body.main = user.map((data) => {
          let obj = {
            row: [
              { data: data.signid, textAlign: 'left' },
              { data: data.name, textAlign: 'left' },
              { data: data.email.value, textAlign: 'left' },
              { data: data.phone.value, textAlign: 'left' },
              { data: data.rankposition, textAlign: 'left' },
              { data: data.position, textAlign: 'left' },
              // , { data : data.comidnum }
              { data: data.grade.text, textAlign: 'left' }
            ]
          };

          obj = cm.defalutTableStaffDivisionSet(obj.row, 2, data.orgCode);
          obj.clickFunc = this.staffClick;
          obj.clickData = { staff: data };
          return obj;
        });
      }
    }

    return (
      <Modal className="modal-large" size={size} dimmer={dimmer} open={open} onClose={(e) => close('close', false)}>
        <Modal.Header>{title || '사용자 선택'}</Modal.Header>
        <Modal.Content style={style.content}>
          {staffList ? (
            <div>
              <div className="form-input">
                <Input
                  value={keyword || ''}
                  action={{
                    icon: 'search',
                    onClick: this.handleEvent
                  }}
                  placeholder="id, 이름, 이메일, 휴대전화번호"
                  onChange={this.handleChange}
                  onKeyPress={this.handleEntEvent}
                />
              </div>

              <div className="table-box">
                <Commons.TableForm tabledata={tabledata} selectable="true" />
              </div>

              <div className="table-paging">
                <Commons.Pagination
                  page={page}
                  pageRow={pagerow}
                  pageBlock={10}
                  totalCount={totalcount}
                  pageClick={this.pageClick}
                />
              </div>
            </div>
          ) : (
            <div style={{ height: '632px' }}>
              <Commons.LoadingBar />
            </div>
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button positive content="확인" onClick={(e) => close('close', false)} />
        </Modal.Actions>
      </Modal>
    );
  }
}

StaffSearchModal.propTypes = propTypes;
StaffSearchModal.defaultProps = defaultProps;

StaffSearchModal = connect((state) => ({
  staffList: state.commons.staff
}))(StaffSearchModal);

export default StaffSearchModal;
